<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>Payment to Merchant</h1>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Filter Payment</h3>
          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse">
              <i class="fa fa-minus"></i>
            </button>
          </div>
        </div>

        <div class="box-body" style="overflow: unset;">
          <div class="row">
            <div class="col-12 col-sm-12">
              <div class="form-group">
                <label for="booking-no">Booking No.</label>

                <input
                  type="text"
                  class="form-control"
                  id="bookingNo"
                  placeholder="Booking No"
                  v-model="params.booking_no"
                />
              </div>
            </div>
          </div>

          <hr class="divider" />

          <div class="row">
            <div class="col-12 col-sm-4">
              <div class="form-group">
                <label for="customer-name">Customer Name</label>

                <input
                  type="text"
                  class="form-control"
                  id="customerName"
                  placeholder="Customer Name"
                  v-model="params.member_name"
                />
              </div>
            </div>

            <div class="col-12 col-sm-4">
              <div class="form-group">
                <label for="departureDate">Departure Date</label>

                <datepicker
                  id="departureDate"
                  format="yyyy-MM-dd"
                  placeholder="Departure Date"
                  wrapper-class="custom-vdp"
                  input-class="form-control"
                  :clear-button="true"
                  @selected="(date) => { onDateSelected('departureDate', date) }">
                </datepicker>
              </div>
            </div>

            <div class="col-12 col-sm-4">
              <div class="form-group">
                <label for="productName">Product Name</label>

                <input
                  type="text"
                  class="form-control"
                  id="productName"
                  placeholder="Product Name"
                  v-model="params.product_name"
                />
              </div>
            </div>
          </div>

          <div class="row">

            <div class="col-12 col-sm-4">
              <div class="form-group">
                <label for="merchantName">Merchant Name</label>

                <v-select
                  id="merchant"
                  name="merchant"
                  label="label"
                  v-model="params.merchant"
                  :options="list.merchants"
                  placeholder="Select Merchant"
                ></v-select>
              </div>
            </div>

            <div class="col-12 col-sm-4">
              <div class="form-group">
                <label>Booking Date</label>

                <div class="row date-row">
                  <div class="col-12 col-sm-6">
                    <datepicker
                      id="bookingDateFrom"
                      format="yyyy-MM-dd"
                      wrapper-class="custom-vdp"
                      input-class="form-control"
                      placeholder="From"
                      :clear-button="true"
                      @selected="(date) => { onDateSelected('bookingDateFrom', date) }">
                    </datepicker>
                  </div>

                  <div class="col-12 col-sm-6">
                    <datepicker
                      id="bookingDateTo"
                      format="yyyy-MM-dd"
                      wrapper-class="custom-vdp"
                      input-class="form-control"
                      placeholder="To"
                      :clear-button="true"
                      @selected="(date) => { onDateSelected('bookingDateTo', date) }">
                    </datepicker>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 col-sm-4">
              <div class="form-group">
                <label for="status-payment">Status Payment</label>

                <select v-model="params.status_payment" class="form-control" id="status-payment">
                  <option value>Select Status</option>
                  <option value="paid">Paid</option>
                  <option value="unpaid">Unpaid</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="box-footer">
          <button 
            type="button" 
            @click='onExportCsv()'
            class="btn btn-success">
            Export CSV
          </button>

          <button 
            type="button" 
            class="btn btn-primary pull-right" 
            @click="fetch">
            Search
          </button>
        </div>
      </div>

      <div class="box box-success">
        <div class="box-body no-padding">
          <div class="table-responsive">
            <table id="table" class="table table-bordered table-striped">
              <thead>
                <tr class="nowrap">
                  <th class="text-center" style="min-width: 15rem">Booking Date</th>
                  <th class="text-center" style="min-width: 12rem">Booking No</th>
                  <th class="text-center" style="min-width: 15rem">Product Name</th>
                  <th style="min-width: 10rem">Departure Date</th>
                  <th style="min-width: 15rem">Merchant</th>
                  <th style="min-width: 15rem">Customer Name</th>
                  <th style="min-width: 12rem">Payment Method</th>
                  <th class="text-center" style="min-width: 10rem">Card Type</th>
                  <th class="text-center" style="min-width: 10rem">Bank Name</th>
                  <th class="text-center" style="min-width: 10rem">Tenor</th>
                  <th class="text-center" style="min-width: 10rem">MDR</th>
                  <th style="min-width: 10rem">Promo Code</th>
                  <th style="min-width: 10rem">Payment Amount</th>
                  <th style="min-width: 10rem">Total Nett Rate</th>
                  <th class="text-center" style="min-width: 10rem">Status Booking</th>
                  <th class="text-center" style="min-width: 10rem">Status Payment</th>
                  <th 
                    class="text-center" 
                    style="min-width: 10rem; ">
                    Select Paid <input type="checkbox" @click="selectAll" v-model="selectAllOrder">
                  </th>
                  <th class="text-center" style="min-width: 10rem">Action</th>
                </tr>
              </thead>

              <tbody>
                <tr v-if="isLoading" key="loading">
                  <td colspan="18" class="text-center">
                    <circle2></circle2>
                  </td>
                </tr>

                <tr v-else-if="!isLoading && orders.length < 1" key="empty">
                  <td colspan="18">Data Not Found</td>
                </tr>

                <tr v-else v-for="(order, index) in orders" :key="index">
                  <td class="text-center">{{ parseTime(order.created_at) }}</td>
                  <td class="text-center">
                    <span
                      class="badge badge-primary pointer"
                      @click="onBookingNoClick(order.hash)"
                    >{{ order.booking_no }}</span>
                  </td>

                  <td>
                    <span class="truncate">{{ order.package_name }}</span>
                  </td>

                  <td>{{ order.visit_date }}</td>

                  <td>
                    <span class="truncate" v-if="order.items[0].product.merchant.name">
                      {{ order.items[0].product.merchant.name }}
                    </span>
                    <span class="text-center" v-else>-</span>
                  </td>

                  <td>
                    <span class="truncate" v-if="order.member_name">{{ order.member_name }}</span>
                    <span class="text-center" v-else>-</span>
                  </td>

                  <td class="text-center">
                    <span v-if="order.payment.payment_method">{{ order.payment.payment_method }}</span>
                    <span class="text-center" v-else>-</span>
                  </td>

                  <td class="text-center">
                    <span v-if="order.payment.card_type">{{ capitalizeFirstLetter(order.payment.card_type) }}</span>
                    <span v-else>-</span>
                  </td>

                  <td class="text-center">
                    <span v-if="order.payment.bank">{{ order.payment.bank }}</span>
                    <span v-else>-</span>
                  </td>

                  <td class="text-center">
                    <span v-if="order.payment.installment_term">{{ order.payment.installment_term }}</span>
                    <span class="text-center" v-else>-</span>
                  </td>

                  <td class="text-center">
                    <span v-if="order.payment.installment_mdr">{{ order.payment.installment_mdr }}%</span>
                    <span class="text-center" v-else>-</span>
                  </td>

                  <td class="text-center">
                    <kbd v-if="order.promo_code.code">{{ order.promo_code.code }}</kbd>
                    <span class="text-center" v-else>-</span>
                  </td>

                  <td>IDR {{ numberFormat(order.payment_amount) }}</td>

                  <td>IDR {{ numberFormat(order.total_nett_rate) }}</td>

                  <td class="text-center">
                    <span
                      class="label label-status"
                      :class="order.status === 'paid' ? 'label-success':'label-default'"
                    >{{ capitalizeFirstLetter(order.status) }}</span>
                  </td>

                  <td class="text-center">
                    <span
                      class="label label-status"
                      :class="order.status_payment === 'paid' ? 'label-success':'label-default'"
                    >{{ capitalizeFirstLetter(order.status_payment) }}</span>
                  </td>

                  <td
                    style="text-align: center">
                    <div v-if='order.status_payment !== "paid"'>
                      <input 
                        type="checkbox" 
                        v-model="selectedOrder" 
                        :value="{
                          merchant_id: order.items[0].product.merchant.id,
                          booking_no: order.booking_no,
                          total_nett: order.total_nett_rate,
                        }">
                    </div>
                    <div v-else></div>
                  </td>

                  <td class="text-center">
                    <button
                      class="btn btn-primary btn-xs"
                      @click="onBookingNoClick(order.hash)"
                    >View Detail</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="box-footer">
          <Pagination :pagination="pagination" @goto-page="changePage" />

          <button @click='onPaidClick' type="button" class="btn btn-primary pull-right">Pay to Merchant</button>
        </div>
      </div>

      <transition name="modal">
        <div class="modal-mask" @click.self="modalDetailVisible = !modalDetailVisible" v-if="modalDetailVisible">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" @click.prevent="modalDetailVisible = !modalDetailVisible">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">Participant Detail - {{ orderDetail.booking_no }}</h4>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-12 col-sm-12">
                      <div class="form-group">
                        <label>Product Name : {{ orderDetail.package_name }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table id="table" class="table table-bordered table-striped">
                      <thead>
                        <tr class="nowrap">
                          <th>Price Name</th>
                          <th>Uniqe Code</th>
                          <th>Nett Rate</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="item in orderDetail.items">
                          <template v-for="ticket in item.tickets">
                            <tr :key="ticket.id">
                              <td>{{ item.price_name }}</td>
                              <td>{{ ticket.unique_code }}</td>
                              <td>IDR {{ numberFormat(item.nett_rate) }}</td>
                            </tr>
                          </template>
                        </template>
                      </tbody>
                    </table>
                  </div>
                  <div class="img-section" v-if="orderDetail.merchant_payment_items.merchant_payment.image !== ''">
                    <label>Bukti Pembayaran: </label>
                    <div>
                      <img 
                        :src="orderDetail.merchant_payment_items.merchant_payment.image" 
                        alt="payment"
                        class='paid-img'>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <transition name="modal">
        <div class="modal-mask" @click.self="modalPaidVisible = !modalPaidVisible" v-if="modalPaidVisible">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" @click.prevent="modalPaidVisible = !modalPaidVisible">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 class="modal-title">Payment to Merchant</h4>
                </div>
                <div class="modal-body">
                  <div class="row">
                    <div class="col-12 col-sm-12">
                      <div class="form-group">
                        <label>Are you sure you want to paid this booking number?</label>
                      </div>
                    </div>
                  </div>
                  <div class="table-responsive scroll">
                    <table id="table" class="table table-bordered table-striped">
                      <thead>
                        <tr class="nowrap">
                          <th>Booking No</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="item in paidData.items">
                          <tr :key="item.booking_no">
                            <td>{{ item.booking_no }}</td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                  <div class="paid-form">

                    <div class="row margin-row">
                      <label 
                        for="merchants_name"
                        class="col-md-2">
                        Merchants Name
                      </label>
                      <div
                        id='merchants_name' 
                        class="col-md-10">
                        {{paidData.merchant_name}}
                      </div>
                    </div>

                    <div class="row margin-row">
                      <label for="transfer_date"
                        class="col-sm-2 label-paid">
                        Transfer Date <span class="req">*</span>
                      </label>

                      <div class="col-sm-5">
                        <datepicker
                          id="transfer_date"
                          placeholder="Transfer Date"
                          :disabled="disabledTransferDate"
                          wrapper-class="custom-vdp"
                          input-class="form-control"
                          :clear-button="true"
                          @selected="(date) => { onDateSelected('transfer_date', date) }">
                        </datepicker>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 col-sm-12">
                        <div class="form-group">
                          <label>Transfer to:</label>
                        </div>
                      </div>
                    </div>

                    <div class="row margin-row">
                      <label 
                        for="bank_owner"
                        class="col-md-2">
                        Bank Owner
                      </label>
                      <div
                        id='bank_owner' 
                        class="col-md-10">
                        {{paidData.bank_owner}}
                      </div>
                    </div>

                    <div class="row margin-row">
                      <label 
                        for="bank_name"
                        class="col-md-2">
                        Bank Name
                      </label>
                      <div
                        id='bank_name' 
                        class="col-md-10">
                        {{paidData.bank_name}}
                      </div>
                    </div>

                    <div class="row margin-row">
                      <label 
                        for="bank_number"
                        class="col-md-2">
                        Bank Number
                      </label>
                      <div
                        id='bank_number' 
                        class="col-md-10">
                        {{paidData.bank_number}}
                      </div>
                    </div>

                    <div class="row margin-row">
                      <label 
                        for="total_nett"
                        class="col-md-2">
                        Total Nett Rate
                      </label>
                      <div
                        id='total_nett' 
                        class="col-md-10">
                        IDR {{ numberFormat(paidData.total_nett) }}
                      </div>
                    </div>

                    <div class="row margin-row">
                      <label for="image"
                        class="col-sm-2 control-label">
                        Upload File <span class="req">*</span>
                      </label>

                      <div class="col-sm-10">
                        <div class="row">
                          <div class="col-md-2">
                            <img v-if="paidData.image.url"
                              class="img-thumbnail img-responsive"
                              alt="Destination Image"
                              :src="parseImage(paidData.image.url, '_thumb')">

                            <img v-else
                              class="img-thumbnail img-responsive"
                              src="/static/img/img_placeholder.png"
                              alt="No image">
                          </div>

                          <div class="col-md-10">
                            <button class="btn btn-sm btn-secondary"
                              @click.prevent="showModal('gallery')">
                              Choose File
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <transition name="slideDown">
                      <modal title="Upload File"
                        v-if="show.gallery">
                        <FileGallery
                          type="category"
                          @update-images="setImage"
                          :selected="paidData.image" />
                      </modal>
                    </transition>

                    <div class="box-footer">
                      <button 
                        type="button" 
                        class="btn btn-default"
                        @click.prevent="modalPaidVisible = !modalPaidVisible">
                        Cancel
                      </button>

                      <button 
                        type="button"
                        @click.prevent="submitPayment"
                        class="btn btn-primary pull-right">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>

<script>

import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import Common from '@/mixins/Common';
import Modal from '@/components/modules/common/Modal';
import FileGallery from '@/components/modules/common/FileGallery';
import Pagination from '@/components/modules/common/Pagination';
import { Circle2 } from 'vue-loading-spinner';
import API_BASEURL, { X_API_KEY } from '@/config';

export default {
  name: 'Payment2Merchant',
  mixins: [Common],

  data() {
    return {
      orders: [],
      pagination: {},
      isLoading: false,
      modalDetailVisible: false,
      modalPaidVisible: false,
      list: {
        merchants: [],
      },

      show: {
        gallery: false,
      },

      selectedOrder: [],
      selectAllOrder: false,

      orderDetail: null,

      paidData: {
        items: [],
        merchant_name: null,
        transfer_date: null,
        bank_owner: null,
        bank_name: null,
        bank_number: null,
        swift_code: null,
        bank_branch: null,
        currency: null,
        total_nett: 0,
        image: {
          id: null,
          url: null,
        },
      },

      params: {
        booking_no: null,
        member_name: null,
        departure_date: null,
        date_from: null,
        date_to: null,
        product_name: null,
        merchant: null,
        status: 'paid',
        status_payment: '',
        export_csv: 0,
        page: 1,
        perpage: 20,
      },

      targetMerchant: null,
    };
  },

  components: {
    Pagination,
    Datepicker,
    Circle2,
    FileGallery,
    Modal,
  },

  computed: {
    disabledTransferDate() {
      return {
        from: moment().toDate(),
      };
    },
  },

  methods: {
    fetch() {
      this.isLoading = true;
      this.selectedOrder = [];
      this.selectAllOrder = false;

      return new Promise((resolve) => {
        this.setListEmpty();

        const queryParams = this.populateQueryParams();
        this.axios.get('/merchant-payments', { params: queryParams })
          .then((response) => {
            const { data, meta } = response.data;
            
            if (!data && (meta.pagination.current_page > meta.pagination.total_pages)) {
              this.setListEmpty();
              this.isLoading = false;
              return;
            }
            
            this.orders = data;
            this.pagination = meta.pagination;
            resolve(data);
            this.isLoading = false;
          })
          .catch((error) => {
            console.log('Fetch error', error);

            if (error.response) {
              this.error = error.response.data.errors;
            }

            if (error) {
              this.$swal({
                title: 'Failed!',
                text: 'Failed to fetch Data',
                type: 'warning',
                timer: 3000,
              });
            }
            this.isLoading = false;
          });
      });
    },

    setListEmpty() {
      this.orders = [];
      this.pagination = {};
    },

    populateQueryParams() {
      const params = {
        booking_no: this.params.booking_no,
        member_name: this.params.member_name,
        visit_date: this.params.departure_date,
        date_from: this.params.date_from,
        date_to: this.params.date_to,
        package_name: this.params.product_name,
        merchant: this.params.merchant ? this.params.merchant.value : null,
        status_payment: this.params.status_payment,
        status: this.params.status,
        export_csv: this.params.export_csv,
        page: this.params.page,
        perpage: this.params.perpage,
      };
      
      return params;
    },

    fetchItem(type) {
      return new Promise((resolve) => {
        this.axios.get(`/${type}`, { params: { perpage: 5000 } })
          .then((response) => {
            const { data } = response.data;
            const results = data.map(item => ({ label: item.name, value: item.id }));
            this.list[type] = results;
            resolve(data);
          })
          .catch((error) => {
            console.log(`Fetch ${type} error`, error);

            if (error.response) {
              this.error = error.response.data.errors;
            }

            if (error) {
              this.$swal({
                title: 'Failed',
                text: `Failed to fetch available ${type}`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#666',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Try again',
              }).then((result) => {
                if (result.value) {
                  this.fetchItem(type);
                }
              });
            }
          });
      });
    },

    onDateSelected(type, date) {
      date = this.parseTime(date, 'YYYY-MM-DD');

      if (type === 'departureDate') {
        this.params.departure_date = date;
      }

      if (type === 'bookingDateFrom') {
        this.params.date_from = date;
      }

      if (type === 'bookingDateTo') {
        this.params.date_to = date;
      }

      if (type === 'transfer_date') {
        this.paidData.transfer_date = date;
      }
    },
    
    changePage(page) {
      this.params.page = page;
      this.fetch();
    },
    
    onBookingNoClick(hash) {
      const config = {
        headers: {
          'X-Api-Key': `${X_API_KEY}`,
        },
      };
      console.log(`${hash}, ${config}`);
      if (!hash) {
        this.modalDetailVisible = false;
        return;
      }

      this.modalDetailVisible = true;

      this.axios.get(`merchant-payments/${hash}`, config)
        .then((response) => {
          const { data } = response.data;
          this.orderDetail = data;
        })
        .catch((error) => {
          console.log('error', error);
        });
    },

    selectAll() {
      this.selectedOrder = [];

      if (!this.selectAllOrder) {
        this.orders
          .filter(data => (data.status_payment !== 'paid'))
          .map(data => this.selectedOrder.push({
            merchant_id: data.items[0].product.merchant.id,
            booking_no: data.booking_no,
            total_nett: data.total_nett_rate,
          }));
      }
    },

    async onPaidClick() {
      const valid = this.validateSelectedOrder(this.selectedOrder);
      if (!valid) return;

      this.setPaidDataEmpty();
      await this.getMerchantData();

      const bankExists = this.checkMerchantBank(this.targetMerchant);
      if (!bankExists) return;

      this.generateFormPaid(this.targetMerchant);
      this.modalPaidVisible = true;
    },

    validateSelectedOrder(datas) {
      if (datas.length < 1) {
        this.$swal({
          title: 'No Order Selected',
          text: 'Please select Order to Pay',
          type: 'warning',
          timer: 5000,
        });
        return false;
      }

      if (!datas.every(data => data.merchant_id === datas[0].merchant_id)) {
        this.$swal({
          title: 'Different Merchants',
          text: 'Payment only valid for the same Merchant',
          type: 'warning',
          timer: 5000,
        });
        return false;
      }

      if (datas.some(data => data.merchant_id === 0)) {
        this.$swal({
          title: 'Merchant not available',
          text: 'Please check the merchant data on the selected order',
          type: 'warning',
          timer: 5000,
        });
        return false;
      }

      return true;
    },

    checkMerchantBank(merchant) {
      if (merchant.banks.length < 1) {
        this.$swal({
          title: 'Incomplete Merchant Data',
          text: 'Please complete the merchant data to continue the payment process',
          type: 'warning',
          timer: 5000,
        });
        return false;
      }

      return true;
    },

    setPaidDataEmpty() {
      const paidData = {
        items: [],
        merchant_id: null,
        merchant_name: null,
        transfer_date: null,
        bank_owner: null,
        bank_name: null,
        bank_id: null,
        bank_number: null,
        swift_code: null,
        bank_branch: null,
        currency: null,
        total_nett: 0,
        image: {
          id: null,
          url: null,
        },
      };

      this.paidData = paidData;
    },

    generateFormPaid(data) {
      this.paidData.items = this.getBookingsNo(this.selectedOrder);
      this.paidData.merchant_id = data.id;
      this.paidData.merchant_name = data.name;
      this.paidData.bank_owner = data.banks[0].account_owner;
      this.paidData.bank_name = data.banks[0].bank_name;
      this.paidData.bank_id = data.banks[0].id;
      this.paidData.bank_number = data.banks[0].account_number;
      this.paidData.swift_code = data.banks[0].swift_code;
      this.paidData.bank_branch = data.banks[0].bank_branch;
      this.paidData.currency = data.banks[0].currency;
      this.paidData.total_nett = this.selectedOrder.reduce((accum, item) => 
        accum + parseInt(item.total_nett, 10), 0,
      );
    },

    getMerchantData() {
      return new Promise((resolve) => {
        this.axios.get(`merchants/${this.selectedOrder[0].merchant_id}`)
          .then((response) => {
            const { data } = response.data;

            this.targetMerchant = data;
            resolve();
          })
          .catch((error) => {
            console.log('error', error);
          });
      });
    },

    getBookingsNo(datas) {
      const bookingsNo = [];
      datas.map(data => (bookingsNo.push({
        booking_no: data.booking_no,
      })));
      return bookingsNo;
    },
    
    submitPayment() {
      const valid = this.validateSubmitOrder(this.paidData);
      if (!valid) return;

      const data = this.generatePaidData();

      this.axios.post('/merchant-payments', data)
        .then(() => {
          this.modalPaidVisible = false;
          this.$swal({
            title: 'Payment Success',
            text: 'Payment for those order numbers successful',
            type: 'success',
            timer: 3000,
          });
          this.fetch();
        })
        .catch((error) => {
          console.log('error', error);

          if (error.response) {
            this.error = error.response.data.errors;
          }

          if (error) {
            this.$swal({
              title: 'Failed',
              text: 'Failed to submit Payment data',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again',
            }).then((result) => {
              if (result.value) {
                this.fetchProduct();
              }
            });
          }
        });
    },

    generatePaidData() {
      const data = {};
      data.merchant_id = this.paidData.merchant_id;
      data.merchant_bank_id = this.paidData.bank_id;
      data.swift_code = this.paidData.swift_code;
      data.bank_name = this.paidData.bank_name;
      data.bank_branch = this.paidData.bank_branch;
      data.account_owner = this.paidData.bank_owner;
      data.account_number = this.paidData.bank_number;
      data.currency = this.paidData.currency;
      data.transfer_date = this.paidData.transfer_date;
      data.image_id = this.paidData.image.id;
      data.items = this.paidData.items;
      data.total = this.paidData.total_nett;

      return data;
    },

    validateSubmitOrder(data) {
      if (!data.transfer_date) {
        this.$swal('Transfer date required', 'Please select transfer date to continue', 'warning');
        return false;
      }

      if (!data.image.id || !data.image.url) {
        this.$swal('Image required', 'Please select image to continue', 'warning');
        return false;
      }

      return true;
    },

    async onExportCsv() {
      let params = '';
      this.params.export_csv = 1;

      const queryParams = await this.populateQueryParams();

      Object.keys(queryParams).forEach((key) => {
        params += `${key}=${queryParams[key] || ''}&`;
      });

      params = params.slice(0, -1);

      const url = `${API_BASEURL}/merchant-payments?${params}`;
      window.location = url;
    },

    showModal(modal) {
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      document.body.classList.add('locked');
    },

    setImage(payload) {
      this.paidData.image = payload.images;
    },
  },

  async created() {
    this.isLoading = true;
    await this.fetchItem('merchants');
    await this.fetch();
    this.isLoading = false;
  },
};
</script>

<style lang="scss" scoped>
@import '../style';

.img-section {
  .paid-img {
    width:auto;
    height:350px;
  }
}

.paid-form{
  margin-top: 25px;

  .margin-row{
    margin-bottom: 10px;
  }

  .label-paid{
    padding-top: 7px;
    margin-bottom: 0;
  }
}

.scroll {
  max-height:150px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/orders/payment2Merchant/Index.vue